<script>
import Layout from '@layouts/blank.vue'

import { mapActions } from 'vuex'

export default {
  page: {
    title: 'Tickers Overview',
    meta: [{ name: 'description', content: 'The Tickers Overview page.' }],
  },

  components: { Layout },
  data: function() {
    return {
      players: [],
      searchText: '',
      isLoading: false,
    }
  },
  computed: {
    filteredPlayers() {
      if (this.searchText !== '' && this.searchText !== null) {
        return this.players.filter((player) => {
          return (
            player.player_name
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) >= 0
          )
        })
      } else {
        return this.players
      }
    },
  },
  mounted() {
    this.loadPlayers()
  },
  methods: {
    ...mapActions('marketValue', ['getLocalPlayers']),
    loadPlayers() {
      this.isLoading = true
      this.getLocalPlayers()
        .then((response) => {
          this.players = response
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.tickerList">
      <header :class="$style.header">
        <h1>All Tickers</h1>
        <br />
        <v-text-field
          v-model="searchText"
          clearable
          hide-details="auto"
          label="Search player"
          append-icon="search"
          dense
          solo
        ></v-text-field>
        <br />
      </header>
      <div :class="$style.content">
        <v-progress-circular
          v-if="isLoading"
          :class="$style.loading"
          indeterminate
          color=""
        ></v-progress-circular>
        <ul v-else :class="$style.playerlist">
          <li v-for="player in filteredPlayers" :key="player.player_id">
            <router-link
              :to="{
                name: 'market-value-player',
                params: { playerId: player.player_id },
              }"
              :class="$style.routerlink"
            >
              <span
                :class="[$style.playername, player.value ? $style.lines : '']"
                >{{ player.player_name }}</span
              >
              <span v-if="player.value" :class="$style.playervalue">{{
                player.value
              }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.tickerList {
  padding: 1rem 2rem;
  background-color: #fff;
}

.content {
  height: 30rem;
  overflow: scroll;
}

.header {
  height: 9rem;
}

.routerlink {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
}

.playername {
  text-decoration: underline;
}

.lines::after {
  float: right;
  width: 0;
  text-decoration: none;
  white-space: nowrap;
  content: '. . . . . . . . . . . . . . . . . . . . . . . . . . . .';
}

.playervalue {
  font-size: 1rem;
  color: $color-accent;
  background-color: white;
}

.loading {
  display: block;
  margin: 0 auto;
  color: $color-secondary;
}

.playerlist {
  height: 100%;
  padding-left: 0 !important;
  list-style-type: none;
}
</style>
